import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['slide'];

  connect() {
    const activeSlideIndex = this.slideTargets.findIndex(slide =>
      slide.classList.contains('slide--active')
    );

    this.currentIndex = Math.max(activeSlideIndex, 0);
    this.#hideSlides();
    this.#showCurrentSlide();
  }

  next() {
    if (this.currentIndex < this.slideTargets.length - 1) {
      this.currentIndex++;
      this.#hideSlides();
      this.#showCurrentSlide();
    }
  }

  previous() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.#hideSlides();
      this.#showCurrentSlide();
    }
  }

  #hideSlides() {
    this.slideTargets.forEach((slideTarget) => {
      slideTarget.classList.add('hide');
    });
  }

  #showCurrentSlide() {
    this.slideTargets[this.currentIndex].classList.remove('hide');
  }
}
